import { z } from 'zod'
import { E164PhoneSchema } from '../../../../@shared/infra/schemas/E164Phone.schema'
import { NotificationChannelEnum } from '../../../domain/enums/NotificationChannel.enum'
import { NotifiedUser } from '../../../domain/entities/NotifiedUser'
import IMask from 'imask'

const phoneMask = IMask.createMask({
	mask: '+00 (00) 00000-0000',
})

export const NotifiedUserSchema = z
	.object({
		id: z.uuid().nonempty(),
		nome: z.string(),
		email: z.email().nonempty(),
		telefone: E164PhoneSchema.nullable(),
		identificador_chat_telegram: z.number().nonnegative().nullable().optional(),
		canais_comunicacao: z.array(z.enum(NotificationChannelEnum)),
		ids_areas_monitoradas_vinculadas: z.array(z.uuid()),
	})
	.transform((data) => {
		if (data.telefone) phoneMask.resolve(data.telefone)
		return new NotifiedUser(
			data.nome,
			data.email,
			phoneMask.value,
			data.ids_areas_monitoradas_vinculadas,
			data.canais_comunicacao,
			data.identificador_chat_telegram ?? undefined,
			data.id,
		)
	})
